import { render, staticRenderFns } from "./MultiSelectTag.vue?vue&type=template&id=23c82f5e&scoped=true"
import script from "./MultiSelectTag.vue?vue&type=script&lang=js"
export * from "./MultiSelectTag.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectTag.vue?vue&type=style&index=0&id=23c82f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c82f5e",
  null
  
)

export default component.exports